import React, { useRef, useEffect } from 'react';

const drawOnCanvas = (canvas, commands) => {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // 描画の初期化
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // デフォルト設定
    ctx.strokeStyle = 'white';
    ctx.fillStyle = 'white';
    ctx.lineWidth = 1;

    if (!commands || commands.length === 0) return;

    commands.forEach(cmd => {
        switch (cmd.command) {
            case 'clear':
                ctx.fillStyle = 'black';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                break;
            case 'color':
                const color = `rgb(${cmd.r}, ${cmd.g}, ${cmd.b})`;
                ctx.strokeStyle = color;
                ctx.fillStyle = color;
                break;
            case 'line':
                ctx.beginPath();
                ctx.moveTo(cmd.x1, cmd.y1);
                ctx.lineTo(cmd.x2, cmd.y2);
                ctx.stroke();
                break;
            case 'rect':
                ctx.fillRect(cmd.x, cmd.y, cmd.w, cmd.h);
                break;
            case 'circle':
                ctx.beginPath();
                ctx.arc(cmd.cx, cmd.cy, cmd.r, 0, 2 * Math.PI);
                ctx.fill();
                break;
            case 'pixel':
                ctx.fillRect(cmd.x, cmd.y, 1, 1);
                break;
            default:
                break;
        }
    });
};

const CanvasDisplay = ({ commands }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            drawOnCanvas(canvasRef.current, commands);
        }
    }, [commands]);  // commandsが変更されたら再描画

    return (
        <canvas 
            ref={canvasRef} 
            width="400" 
            height="400" 
            className="bg-gray-900 border-2 border-gray-700 rounded-lg"
        ></canvas>
    );
};

export default CanvasDisplay;